/**
 * Kleiner Zwischenspeicher der Artikelbilder (Welle 4g) nur im Arbeitsspeicher dieser Seite (kein localStorage, kein Cache des
 * Browsers: der Server liefert `no-store`), damit eine Liste beim Sortieren oder Blättern nicht jedes Bild neu lädt. Höchstens
 * 150 Bilder à rund 50 KB. Beim An- und Abmelden wird er geleert: Die Bilder gehören nicht der nächsten Person am Gerät.
 */
const cache = new Map<string, string>();
const CACHE_LIMIT = 150;

export function cachedItemImage(key: string): string | undefined {
  return cache.get(key);
}

export function rememberItemImage(key: string, dataUrl: string): void {
  cache.delete(key);
  cache.set(key, dataUrl);
  const oldest = cache.keys().next();
  if (cache.size > CACHE_LIMIT && oldest.done !== true) cache.delete(oldest.value);
}

export function clearItemImageCache(): void {
  cache.clear();
}
